import React from 'react';
import cx from 'classnames'
import styles from './styles.module.scss';

interface BackButtonProps {
  onClick: () => void,
  title?: string,
  className?: string
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, title = "back", className }) => {
  return (
    <div onClick={onClick} className={cx(styles.backButtonContainer,className)}>
      <i className="paperflite-left-arrow"></i>
      <span className={styles.title}>{title} </span>
    </div>
  )
}


export default BackButton;